import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { NotificationModel } from "./notification.model";
import { CommonModule } from "@angular/common";
import { AddEditNotificationComponent } from "./add-edit-notification/add-edit-notification.component";
import { FlyoutService } from "src/app/shared/services/flyout.service";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatIconModule } from "@angular/material/icon";
import { NotificationService } from "src/app/api/notification.service";
import { GenericResponse } from "src/app/shared/common/api-response.model";
import { MatDialog } from "@angular/material/dialog";
import {
  ConfirmDialogData,
  DialogAnimationComponent,
} from "src/app/shared/components/dialog-animation/dialog-animation.component";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";
import { NotificationAudience } from "src/app/shared/common/common.enum";
import { MatTooltip } from "@angular/material/tooltip";
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from "@angular/material/slide-toggle";

@Component({
  selector: "app-notification-list",
  imports: [
    CommonModule,
    AddEditNotificationComponent,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatTooltip,
    MatSlideToggleModule,
  ],
  templateUrl: "./notification-list.component.html",
  styleUrl: "./notification-list.component.css",
})
export class NotificationListComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  notificationList!: NotificationModel[];
  private flyoutService = inject(FlyoutService);
  private notificationService = inject(NotificationService);
  private gbService = inject(GlobalServiceService);
  notification!: NotificationModel | null;
  showNotificationList = signal<boolean>(true);
  dataSourceUI = new MatTableDataSource<NotificationModel>([]);
  isMobile = this.gbService.isMobile;
  displayedColumns: string[] = !this.gbService.isMobile
    ? ["Title", "Audience", "Placement", "StartTime", "EndTime", "Edit"]
    : ["Title", "Placement", "Edit"];

  notificationAudienceEnum = NotificationAudience;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.getNotificationList();
    this.showNotificationList = this.flyoutService.isResetFlyout;
  }

  private getNotificationList() {
    this.notificationService.getUserNotification().subscribe({
      next: (res: GenericResponse<NotificationModel[]>) => {
        if (res.status) {
          this.notificationList = res.Result.map((ele: NotificationModel) => {
            return {
              ...ele,
              StartAt: this.gbService.convertUtcToLocalString(ele.StartAt),
              EndAt: this.gbService.convertUtcToLocalString(ele.EndAt),
            };
          });
          this.dataSourceUI.data = this.notificationList;
        }
      },
    });
  }

  openDialog(
    notification: NotificationModel,
    enterAnimationDuration: string = "0ms",
    exitAnimationDuration: string = "0ms",
  ): void {
    const data: ConfirmDialogData = {
      title: `Delete Notification`,
      message: `Would you want to delete ${notification.Title}?`,
      okText: "Delete",
      cancelText: "Cancel",
    };

    const dialogRef = this.dialog.open(DialogAnimationComponent, {
      width: "350px",
      data,
      enterAnimationDuration,
      exitAnimationDuration,
    });
    dialogRef.afterClosed().subscribe((ok: boolean) => {
      if (ok) {
        this.deleteNotification(notification);
      }
    });
  }

  onStatusToggleChange(event: MatSlideToggleChange, row: NotificationModel) {
    const previous = row.IsActive;
    const next = event.checked;

    // Open the confirm dialog
    const dialogRef = this.dialog.open(DialogAnimationComponent, {
      width: "350px",
      data: {
        title: next ? "Activate notification?" : "Deactivate notification?",
        message: next
          ? "Are you sure you want to activate this notification?"
          : "Are you sure you want to deactivate this notification?",
      },
      enterAnimationDuration: "200ms",
      exitAnimationDuration: "200ms",
    });

    dialogRef.afterClosed().subscribe((ok: boolean) => {
      if (ok) {
        // User confirmed -> commit change and perform action
        row.IsActive = next;

        this.activeNotification(row); // your method
      } else {
        // // User canceled -> revert to previous
        // row.IsActive = previous;
        // const data: NotificationModel =
        //   this.notificationList.find(
        //     (x) => x.NotificationId == row.NotificationId
        //   ) ?? new NotificationModel();
        // data.IsActive = previous;
        // this.dataSourceUI.data = this.notificationList;
        // // this.dataSourceUI.data = notif
        // this.cdr.markForCheck();
        this.getNotificationList();
      }

      // Ensure UI reflects the final value (especially if inside OnPush or table)
    });
  }

  onNewApplication() {
    this.notification = null;
    this.showNotificationList.set(false);
    this.flyoutService.setFlyoutHeader("");
  }
  onCancelHandel(value: string) {
    this.showNotificationList.set(true);
    this.flyoutService.setFlyoutHeader(value);
  }

  onEditClick(row: NotificationModel) {
    this.notification = row;
    this.showNotificationList.set(false);
    this.flyoutService.setFlyoutHeader(row.Title);
  }
  onDeleteClick(row: NotificationModel) {
    this.notification = row;
    this.flyoutService.setFlyoutHeader(row.Title);
  }

  deleteNotification(notification: NotificationModel) {
    const userId = this.gbService.userData()?.["user-id"];
    const payload: NotificationModel = {
      ...notification,
       StartAt: this.gbService.combineDateAndTimeToString(
        new Date(notification.StartAt),
        new Date(notification.StartAt),
      ),
      EndAt: this.gbService.combineDateAndTimeToString(
        new Date(notification.EndAt),
        new Date(notification.EndAt),
      ),
      IsDeleted: true,
      InsertedBy: userId?.toString() ?? "0",
    };
    this.notificationService.submitUserNotification(payload).subscribe({
      next: (res: GenericResponse<NotificationModel>) => {
        if (res.status) {
          this.getNotificationList();
        }
      },
    });
  }

  activeNotification(notification: NotificationModel) {
    const userId = this.gbService.userData()?.["user-id"];
    const payload: NotificationModel = {
      ...notification,
      StartAt: this.gbService.combineDateAndTimeToString(
        new Date(notification.StartAt),
        new Date(notification.StartAt),
      ),
      EndAt: this.gbService.combineDateAndTimeToString(
        new Date(notification.EndAt),
        new Date(notification.EndAt),
      ),
      IsActive: notification.IsActive,
      InsertedBy: userId?.toString() ?? "0",
    };

    this.notificationService.submitUserNotification(payload).subscribe({
      next: (res: GenericResponse<NotificationModel>) => {
        if (res.status) {
          this.getNotificationList();
        }
      },
    });
  }

  onDataRefresh(value: boolean) {
    if (value) {
      this.getNotificationList();
    }
  }

  textTruncate(text: string, length = 30): string {
    return this.gbService.transform(text, length);
  }
}
